






























import Vue from 'vue';
import { cloneDeep } from 'lodash';

import { BFormTextarea } from 'bootstrap-vue';
import GenericCard from '@/components/cards/GenericCard.vue';
import { ModalSize } from '@/components/zen_modal/types';
import CommentsInput from './CommentsInput.vue';
import { putRequest } from '../../../../../../utils/client/client';

export default Vue.extend({
  name: 'EditCommentModal',
  components: {
    GenericCard,
    BFormTextarea,
    CommentsInput,
  },
  props: {
    initialComment: {
      type: Object,
      required: true,
    },
    csrfToken: {
      type: String,
      required: true,
    },
    people: {
      required: true,
      type: Array,
    },
    customPillClasses: {
      type: Array,
      default() {
        return [];
      },
    },
    objectType: {
      type: String,
      required: true,
    },
    objectId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      saving: false,
      comment: cloneDeep(this.initialComment),
      editorContent: {
        html: '',
        mentions: [],
      },
    };
  },
  created() {
    if (this.$store) {
      this.$store.dispatch('modals/changeSize', ModalSize.Small);
    } else {
      this.$emit('updateConfig', { size: ModalSize.Small });
    }
  },
  methods: {
    updateEditorContent(content) {
      this.editorContent = content;
    },
    closeModal() {
      this.$emit('close');
    },
    async editComment(): Promise<void> {
      try {
        const comment = this.editorContent.html;

        if (comment && comment.length) {
          this.saving = true;
          const mentions = this.editorContent.mentions;
          await putRequest({
            url: `/api/v2/comments/${this.comment.id}`,
            data: {
              description: comment,
              mentions,
              object_id: this.objectId,
              object_type: this.objectType,
            },
            headers: {
              'X-CSRF-Token': this.csrfToken,
            },
          });

          if (this.$store) {
            this.$store.dispatch('modals/confirm');
          } else {
            window.GGRC.zenModal.$emit('reloadPage');
            this.closeModal();
          }
        }
      } catch (error) {
        this.saving = false;
        const showAlert = this.$store ? config => this.$store.dispatch('alerts/show', config) : window.GGRC.Notify;
        showAlert({
          type: 'error',
          message: 'Oops, something went wrong.',
        });
      }
    },
  },
});
